import { render, staticRenderFns } from "./CreateUserView.vue?vue&type=template&id=0b47e731&scoped=true"
import script from "./CreateUserView.vue?vue&type=script&lang=js"
export * from "./CreateUserView.vue?vue&type=script&lang=js"
import style0 from "./CreateUserView.vue?vue&type=style&index=0&id=0b47e731&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b47e731",
  null
  
)

export default component.exports